import {
  BackstageIdentityApi,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import {
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage/plugin-tech-radar';
/* eslint-disable */
import axios from 'axios';
/* eslint-enable */

export class TechRadar implements TechRadarApi {
  idToken: any;
  constructor(props: {
    token: OAuthApi &
      OpenIdConnectApi &
      ProfileInfoApi &
      BackstageIdentityApi &
      SessionApi;
  }) {
    this.idToken = props.token;
  }

  async load(id: string): Promise<TechRadarLoaderResponse> {
    const finalToken = await this.idToken.getIdToken();
    const data = await axios
      .get<TechRadarLoaderResponse>(id, {
        headers: {
          Authorization: `Basic ${finalToken}`,
        },
      })
      .then(res => res.data);

    return data;
  }
}
